import {IServiceFactory} from "../../../service-factory.interface";
import {UnaccompaniedMinorBaseSsr} from "./unaccompanied-minor-base-ssr";

export default class UmSsrType extends UnaccompaniedMinorBaseSsr {
    constructor(services: IServiceFactory) {
        super('UM', services);
    }
}
